import React from 'react'
import "../BestSeller/BestSeller.css"
export default function BestSeller() {
  return (
    <div>
        <div className="badge">Bestseller</div>
    </div>
    
  )
}
